<div [class]="fontSizeClass">
  <app-nav-bar
    [locale]="locale"
    (languageChange)="handleLanguageChange($event)"
    (fontSizeChange)="handleFontSizeChange($event)">
  </app-nav-bar>
  <app-title-bar></app-title-bar>
  <main class="app-content">
    <router-outlet />
  </main>
</div>
